module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eLBPh"))).then(() => module.bundle.root('iDabs'));